import { render, staticRenderFns } from "./poster-v2-edit.vue?vue&type=template&id=4b33e75c&scoped=true&"
import script from "./poster-v2-edit.vue?vue&type=script&lang=js&"
export * from "./poster-v2-edit.vue?vue&type=script&lang=js&"
import style0 from "./poster-v2-edit.vue?vue&type=style&index=0&id=4b33e75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33e75c",
  null
  
)

export default component.exports